import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { postToController } from '../../../../actions/apiActions';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import './Financed.css';

class Financed extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            financed: this.props.sales.financed,
            financeHouse: this.props.sales.financed ? this.props.sales.financeHouse : null,
            financeHouseId: this.props.sales.financed ? this.props.sales.financeHouseId : -1,
            financeHouseList: [],
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleIsFinanced = this.handleIsFinanced.bind(this);
        this.handleListSelection = this.handleListSelection.bind(this);
    }

    async componentDidMount() {
        this.checkSubmit();
        if (this.state.financeHouseList.length === 0) {
            await this.getFinanceHouses();
        }
    }

    checkSubmit() {
        let valid = (this.state.financed !== undefined);
        if (this.state.financed) {
            valid = this.state.financeHouseId > 0;
        }
        this.setState({ nextDisabled: !valid });
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(
                setQuoteData({
                    financed: this.state.financed,
                    financeHouse: this.state.financed? this.state.financeHouse : "",
                    financeHouseId: this.state.financed ? this.state.financeHouseId : -1,
                })
            );
            await this.props.dispatchAction(handleNextStep());
        }
    }

    handleIsFinanced(financed) {
        this.setState({ financed }, () => { this.checkSubmit() });
    }

    handleListSelection(e: Number) {
        let item = this.state.financeHouseList.filter(x => x.id === e)[0];
        this.setState({
            financeHouse: item,
            financeHouseId: e
        }, () => { this.checkSubmit() }
        );
    }

    async getFinanceHouses() {
        await postToController(this.props.dispatch, "GetBuildingFinanceHouses", JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            let dataSet = response.map(item => {
                return ({
                    description: item.description,
                    id: item.id,
                    image: '',
                    productName: item.description
                }) as IDropdownData;
            });
            this.setState({ financeHouseList: dataSet });
        })
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    Is the building financed?
                </div>

                <div className="row mt-4">
                    <div className="col-md-6 text-right mb-4">
                        <button type="button" className={"btn btnOption " + ((this.state.financed === true) ? "btn-solid-red" : "btn-outline-red")} onClick={()=>this.handleIsFinanced(true)}>Yes</button>
                    </div>

                    <div className="col-md-6 text-left mb-4">
                        <button type="button" className={"btn btnOption " + ((this.state.financed === false) ? "btn-solid-red" : "btn-outline-red")} onClick={() => this.handleIsFinanced(false)}>No</button>
                    </div>
                </div>

                {this.state.financed && this.state.financeHouseList.length > 0 &&
                    <div>
                        <KPDropdown
                            id="listFinanceHouses"
                            isBordered={true}
                            showLabelAfterSelection={true}
                            showLabelInside={false}
                            showLabelOutside={true}
                            labelAfterSelection="Who financed the property"
                            label="Who financed the property"
                            title="Who financed the property"
                            data={this.state.financeHouseList}
                            handleSelection={(e) => this.handleListSelection(Number(e))}
                            selectedValue={this.state.financeHouse}
                        />
                    </div>
                }

                {this.state.financed !== undefined &&
                    <div className="row mt-4">
                        <div className="col-12 justify-content-center mt-4">
                            <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Financed);